module.exports = __webpack_public_path__ + "static/tower.ee680cc4.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Workshops/Towers/tower.png
// module id = 741
// module chunks = 213534597649335